import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrentUserService } from '@src/app/features/authentication/services/current-user.service';
import { TranslateService } from '@ngx-translate/core';
import { getLanguageExtensionForUserLanguage } from '@src/app/utils/language.utils';

@Injectable({ providedIn: 'root' })
export class TempLangInterceptor implements HttpInterceptor {
  private currentUserService = inject(CurrentUserService);
  private translateService = inject(TranslateService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = this.currentUserService.getCurrentUser();

    const effectiveLang = (user && user.tempLang) || getLanguageExtensionForUserLanguage(this.translateService);

    const request = effectiveLang ? req.clone({ headers: req.headers.set('X-Accept-Language', effectiveLang) }) : req;

    return next.handle(request);
  }
}
